import { useState } from 'react';
import MeetResultsData from './MeetResultsData';

const useMeetResutlsData = () => {
  const [meetResultsState, setMeetResultsState] = useState(MeetResultsData.INITIAL_STATE);
  const [meetRelayResultsState, setMeetRelayResultsState] = useState(MeetResultsData.INITIAL_STATE);
  const [meetResultsStatusState, setMeetResultsStatusState] = useState(MeetResultsData.INITIAL_STATE);

  const postMeetResults = (meetResultsObj, incrementalMeetTimes, isLastUploadFile) => MeetResultsData.postMeetResultsData(meetResultsObj, incrementalMeetTimes, isLastUploadFile, meetResultsState, setMeetResultsState);
  const postMeetRelayResults = (meetResultsObj, incrementalMeetTimes, isLastUploadFile) => MeetResultsData.postMeetResultsData(meetResultsObj, incrementalMeetTimes, isLastUploadFile, meetRelayResultsState, setMeetRelayResultsState);
  
  const getMeetResultsUploadStatus = (meetId) => MeetResultsData.getMeetResultsUploadStatusData(meetId, meetResultsStatusState, setMeetResultsStatusState);

  return {
    meetResultsState,
    meetRelayResultsState,
    meetResultsStatusState,
    postMeetResults,
    postMeetRelayResults,
    getMeetResultsUploadStatus
  };
}

export default useMeetResutlsData;